import Swal from 'sweetalert2'

const globalOptions = {
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#aaa'
}

const alerts = {
  $alert(message, title, type, options) {
    const mixedOptions = { ...globalOptions, ...(options || {}) }
    mixedOptions.title = title || mixedOptions?.title || ''
    mixedOptions.text = message || mixedOptions?.text || ''
    mixedOptions.icon = type || mixedOptions.type || ''
    if (Swal) {
      return new Promise(function (resolve) {
        Swal.fire(mixedOptions)
          .then(function () {
            resolve(true)
          })
          .catch(function () {
            resolve(true)
          })
      })
    } else {
      return new Promise(function (resolve, reject) {
        alert(`${mixedOptions.title}: ${mixedOptions.text}`)
        resolve(true)
      })
    }
  },
  $confirm(message, title, type, options) {
    const mixedOptions = { ...globalOptions, ...(options || {}) }
    mixedOptions.title = title || mixedOptions?.title || ''
    mixedOptions.text = message || mixedOptions?.text || ''
    mixedOptions.icon = type || mixedOptions?.type || ''
    mixedOptions.showCancelButton = true
    if (Swal) {
      return new Promise(function (resolve, reject) {
        Swal.fire(mixedOptions)
          .then(function (r) {
            if (r.value === true) {
              resolve(true)
            } else reject()
          })
          .catch(function () {
            return reject()
          })
      })
    } else {
      return new Promise(function (resolve, reject) {
        try {
          const confirmed = confirm(`${mixedOptions.title}: ${mixedOptions.text}`)
          if (confirmed) {
            resolve(true)
          } else {
            reject()
          }
        } catch (e) {
          reject()
        }
      })
    }
  },
  $prompt(message, defaultText, title, type, options) {
    const mixedOptions = { ...globalOptions, ...(options || {}) }
    mixedOptions.title = title || mixedOptions?.title || ''
    mixedOptions.inputValue = defaultText || ''
    mixedOptions.text = message || mixedOptions?.text || ''
    mixedOptions.icon = type || mixedOptions?.type || ''
    mixedOptions.showCancelButton = true
    mixedOptions.input = mixedOptions?.input || 'text'
    if (Swal) {
      return new Promise(function (resolve, reject) {
        Swal.fire(mixedOptions)
          .then(function (r) {
            if (r.value) {
              resolve(r.value)
            } else reject()
          })
          .catch(function () {
            return reject()
          })
      })
    } else {
      return new Promise(function (resolve, reject) {
        try {
          const value = prompt(`${mixedOptions.title}: ${mixedOptions.text}`, mixedOptions.inputValue)
          if (value !== null) {
            resolve(value)
          } else {
            reject()
          }
        } catch (e) {
          reject()
        }
      })
    }
  },
  $fire(options) {
    const mixedOptions = { ...globalOptions, ...(options || {}) }
    return Swal.fire(mixedOptions)
  }
}

export default alerts
